<template lang="pug">
header#hd
  #hd_top
    button#btn_gnb.btn_gnb_close.btn_gnb_open(@click='sideBar = !sideBar') 메뉴
    #logo
      a(@click='$_goTo({name: "admin"})')
        img(:src='require("../../assets/images/admin_logo.png")' alt='administrator')
    #tnb
      ul
        li.tnb_li
          a.tnb_service(@click='$_goTo({name: "index"})') 홈페이지 바로가기
        li.tnb_li
          a.tnb_service(@click='logout()') 로그아웃
  nav#gnbb.gnb_large.gnb_small
    ul.gnb_ul
      li.gnb_li.on(@mouseover="!sideBar ? hover.content = true : null" @mouseout="hover.content = false")
        button.btn_op.menu-100.menu-order-1(@click="clickMenu('content')") 컨텐츠관리
        .gnb_oparea_wr
          .gnb_oparea(:class='[(sideBar && side.content) || hover.content ? "open" : "" ]')
            h3 컨텐츠관리
            ul
              li
                a.gnb_2da(@click='$_goTo({name: "history-admin"})') 연혁 관리
              li
                a.gnb_2da(@click='$_goTo({name: "beer-admin"})') 맥주 레시피 관리
              li
                a.gnb_2da(@click='$_goTo({name: "news-admin"})') 보도자료
              li
                a.gnb_2da(@click='$_goTo({name: "store-admin"})') 설치 매장
              li
                a.gnb_2da(@click='$_goTo({name: "contact-admin"})') 문의
      li.gnb_li.on(@mouseover="!sideBar ? hover.popup = true : null" @mouseout="hover.popup = false")
        button.btn_op.menu-100.menu-order-2(@click="clickMenu('popup')") 팝업관리
        .gnb_oparea_wr
          .gnb_oparea(:class='[(sideBar && side.popup) || hover.popup ? "open" : "" ]')
            h3 팝업관리
            ul
              li
                a.gnb_2da(@click='$_goTo({name: "popup-admin"})') 팝업관리
      li.gnb_li.on(@mouseover="!sideBar ? hover.visitor = true : null" @mouseout="hover.visitor = false")
        button.btn_op.menu-100.menu-order-3(@click="clickMenu('visitor')") 접속자집계
        .gnb_oparea_wr
          .gnb_oparea(:class='[(sideBar && side.visitor) || hover.visitor ? "open" : "" ]')
            h3 접속자집계
            ul
              li
                a.gnb_2da(@click='$_goTo({name: "visitor-admin"})') 접속자집계
</template>

<script>
export default {
  components: {},
  data() {
    return {
      side: {
        content: true,
        popup: false,
        visitor: false,
      },
      hover: {
        content: false,
        popup: false,
        visitor: false,
      },
      sideBar: false,
    };
  },
  computed: {},
  methods: {
    logout() {
      const $_self = this;
      // this.$_axios('DELETE', 'admin/session', this.userAccToken).then(() => {});
      $_self.$store.commit('resetStore', {});
      $_self.$_goTo({ name: 'home' });
    },
    clickMenu(menu) {
      this.side.content = true;
      this.side.popup = false;
      this.side.visitor = false;

      switch (menu) {
        case 'content':
          this.side.content = true;
          break;
        case 'popup':
          this.side.popup = true;
          this.side.content = false;
          break;
        case 'visitor':
          this.side.visitor = true;
          this.side.content = false;
          break;
        default:
      }
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
@import '../../assets/css/admin.css';
.open {
  display: block !important;
}
h3 {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
#tnb ul li a.tnb_service {
  font-size: 0.75rem;
}
</style>
